import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8b5904b6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8b5904b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5904b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b5904b6')) {
      api.createRecord('8b5904b6', component.options)
    } else {
      api.reload('8b5904b6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8b5904b6&scoped=true", function () {
      api.rerender('8b5904b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Weforsys-userSelect/index.vue"
export default component.exports